<template>
  <div class="dialog-map">
    <div class="search-wrap">
      <el-select  @change="changeMap" class="wd120" size="mini" v-model="mapType">
        <el-option  v-for="item in mapTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-cascader filterable @change="cityChange" size="mini" style="margin-left: 10px;width:140px;" v-show="mapType=='gdMap'"  placeholder="请选择"  ref="cascaderFirst" v-model="currentCity" :options="options"></el-cascader>
      <el-input class="wd300" size="mini" :placeholder="mapType=='gdMap'?'请先选择终端所在城市再搜索':'请先在地图左上角选择终端所在的城市再搜索'" v-model="locationSearch"></el-input>
      <el-button class="wd60" size="mini" type="info" @click="search">查询</el-button>
    </div>
    <div class="map-contain">
      <div class="list-wrap" :style="searchList&&searchList.length<=7?'overflow-y:hidden':''">
        <!-- 百度地图搜索结果 -->
        <div v-show="mapType=='bdMap'" :style="currentPoint&&item.point&&item.point.lat==currentPoint.lat?'color:#4fa1a4':''" class="item" @click="choosePosition(item)" v-for="item in searchList" :key="item.url">
          <div class="title">{{ item.title}}</div>
          <div class="address">地址：{{ item.address }}</div>
        </div>
        <!-- 高德地图搜索结果 -->
        <div v-show="mapType=='gdMap'" :style="currentPoint&&item.location&&item.location.lat==currentPoint.lat?'color:#4fa1a4':''" class="item" @click="choosePosition(item)" v-for="item in searchList" :key="item.uid">
          <div class="title">{{ item.name }}</div>
          <div class="address">地址：{{ item.address }}</div>
        </div>
        <div class="no-data" v-if="searchList.length == 0">
          <img style="width: 320px;margin-top: 100px;" src="../assets/images/no_data.png" alt="" />
           暂无数据
        </div>
      </div>
      <div v-show="mapType=='bdMap'" class="map" id="mapContainerBd"></div>
      <div v-show="mapType=='gdMap'" class="map" id="mapContainerGd"></div>
      <div class="current-point" v-if="currentPoint">
        <div>当前选中地址：{{ currentPoint.address }}</div>
        <div>坐标：{{currentPoint.lat  }},{{currentPoint.lng  }}</div>
      </div>
    </div>
    <div class="btns">
      <el-button class="wd60" size="mini" type="info" @click="close">取消</el-button>
      <el-button class="wd60" size="mini" type="info" @click="getMarkers">确认</el-button>
    </div>

  </div>
</template>

<script>
import areaJson from '../assets/js/china_address_v4.js';
export default {
  name: 'Map',
  data() {
    return {
      areaJson: areaJson,
      options:[],
      mapType: 'bdMap',
      mapTypeList: [{ label: '百度地图', value: 'bdMap' }, { label: '高德地图', value: 'gdMap' }],
      locationSearch: null,
      bdMap: null,
      gdMap: null,
      currentPoint: null,
      searchList: [],

      marker: null,//高德地图标记点
      currentCity: null//高德地图当前选择的城市



    };
  },
  props: ['markers'],
  mounted() {
    this.initCity();
    this.$nextTick(()=>{
      this.loadBdMap(true);
    })
  
  },
  methods: {
    cityChange(res){
      console.log(res);
        // 定义城市编码  
        var cityCode = res[1];
        this.gdMap.setCity(cityCode)
        this.gdMap.setZoom(15);
    },
    initCity() {
      let options = [];
      let newAreaJson = JSON.parse(JSON.stringify(this.areaJson))
      newAreaJson.forEach(m => {
        if (m.children) {
          m.children.forEach(n => {
            delete n.children;
            delete n.parentGuids;
          })
        }
        options.push({
          label: m.label,
          value: m.value,
          children: m.children
        })
      })
      this.options = options;
    },
    changeMap(val) {
      this.locationSearch = null;
      this.bdMap = null;
      this.gdMap = null;
      this.currentPoint = null;
      this.searchList = [];
      if (val == 'bdMap') {
        this.$nextTick(() => {
          this.loadBdMap();
        })
      } else {
        this.currentCity = ['110000', '110100'];
        this.$nextTick(() => {
          this.loadGdMap();
        })
      }
    },
    //初始化百度地图
    loadBdMap(isFirstInit) {
      // 创建Map实例
      const _this = this;
      var bdMap = new BMap.Map('mapContainerBd');
      this.bdMap = bdMap;
      // 初始化地图,设置中心点坐标和地图级别
      // 30.60877841465868,114.31887381920122
      bdMap.centerAndZoom(new BMap.Point(116.404, 39.915), 16);
      // 开启鼠标滚轮缩放 
      bdMap.enableScrollWheelZoom(true);
          // 创建城市选择控件
      var cityControl = new BMap.CityListControl({
          // 控件的停靠位置（可选，默认左上角）
          anchor: BMAP_ANCHOR_TOP_LEFT,
          // 控件基于停靠位置的偏移量（可选）
          offset: new BMap.Size(10, 5)
        });
      // 将控件添加到地图上
      bdMap.addControl(cityControl);

      //从页面传过来的点
      if (this.markers.lat && isFirstInit) {
        //地图上标记
        this.markerPoint();
      }

      bdMap.addEventListener('click', function (e) {
        //点击新增覆盖物
        bdMap.clearOverlays();
        bdMap.addOverlay(new BMap.Marker(e.point));
        //设置中心点
        bdMap.setViewport({ center: e.point, zoom: 16 });
        var geoc = new BMap.Geocoder();
        geoc.getLocation(e.point, function (rs) {
          console.log(rs)
          let obj = {
            lat: rs.point.lat,
            lng: rs.point.lng,
            address: `${rs.addressComponents.province}${rs.addressComponents.city}${rs.addressComponents.district}${rs.addressComponents.street}${rs.addressComponents.streetNumber}`,
            province: _this.getCode('province', rs.addressComponents.province),
            city: _this.getCode('city', rs.addressComponents.province, rs.addressComponents.city),
            district: _this.getCode('district', rs.addressComponents.province, rs.addressComponents.city, rs.addressComponents.district),
            street:`${rs.addressComponents.street}${rs.addressComponents.streetNumber}`
          };
          _this.currentPoint = obj;
          console.log(_this.currentPoint)
        })
      });
    },
    markerPoint(){
        let bdMap = this.bdMap;
        let e = this.markers;
        let point = new BMap.Point(e.lng,e.lat);
        let _this = this;
        bdMap.clearOverlays();
        bdMap.addOverlay(new BMap.Marker(point));
        console.log()
        //设置中心点
        bdMap.setViewport({ center:point, zoom: 16 });
        var geoc = new BMap.Geocoder();
        geoc.getLocation(point, function (rs) {
          if(!rs) return;
          let obj = {
            lat: rs.point.lat,
            lng: rs.point.lng,
            address: `${rs.addressComponents.province}${rs.addressComponents.city}${rs.addressComponents.district}${rs.addressComponents.street}${rs.addressComponents.streetNumber}`,
            province: _this.getCode('province', rs.addressComponents.province),
            city: _this.getCode('city', rs.addressComponents.province, rs.addressComponents.city),
            district: _this.getCode('district', rs.addressComponents.province, rs.addressComponents.city, rs.addressComponents.district),
          };
          _this.currentPoint = obj;
        })
    },
    //初始化高德地图
    loadGdMap(){
      // 创建Map实例
      const _this = this;
      var gdMap = new AMap.Map('mapContainerGd', {
        resizeEnable: true,
        zoom: 15, //地图显示的缩放级别
        center: [116.397428, 39.90923]
      });
      this.gdMap = gdMap;
      gdMap.on('click', (e) => {
        let marker = new AMap.Marker({
          icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
          position: [e.lnglat.lng, e.lnglat.lat]
        });
        if (_this.marker) {
          gdMap.remove(_this.marker)
        }
        gdMap.add(marker);
        gdMap.setFitView();
        _this.marker = marker;
        new AMap.Geocoder(null).getAddress([e.lnglat.lng, e.lnglat.lat], function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              let rs  = result.regeocode;
              console.log(rs)
              let obj = {
                lat:  e.lnglat.lat,
                lng: e.lnglat.lng,
                address: `${rs.addressComponent.province}${rs.addressComponent.city || rs.addressComponent.province}${rs.addressComponent.district}${rs.addressComponent.street}${rs.addressComponent.streetNumber}`,
                province: _this.getCode('province', rs.addressComponent.province),
                city: _this.getCode('city', rs.addressComponent.province, rs.addressComponent.city || rs.addressComponent.province),
                district: _this.getCode('district', rs.addressComponent.province, rs.addressComponent.city || rs.addressComponent.province, rs.addressComponent.district),
                street:`${rs.addressComponent.street}${rs.addressComponent.streetNumber}`
              };
              _this.currentPoint = obj;
              console.log( _this.currentPoint)
          
            }
        })

      });

    },
    //搜索
    search(){
      if(this.mapType == 'bdMap'){
        this.searchBdMap();
      }else{
        this.searchGdMap();
      }
    },
    //点击搜索后的位置
    choosePosition(item){
      if(this.mapType == 'bdMap'){
        this.chooseBdPosition(item);
      }else{
        this.chooseGdPosition(item)
      }
    },
    //搜索-百度地图
    searchBdMap() {
      let _this = this;
      // _this.bdMap.clearOverlays();
      let PoiOptions = {
        onSearchComplete: function (results) {
          console.log(results)
          if (results?.Vr?.length) {
            _this.searchList = results.Vr;
          }
          if (results.Yr && results.Yr.length) {
            _this.searchList = results.Yr;
          }
          if (results.Rr && results.Rr.length) {
            _this.searchList = results.Rr;
          }
          if (results.Ir && results.Ir.length) {
            _this.searchList = results.Ir;
          }
          if (results.Kr && results.Kr.length) {
            _this.searchList = results.Kr;
          }
          if (results.as && results.as.length) {
            _this.searchList = results.as;
          }
          console.log( _this.searchList)
        },
        pageCapacity:100,
        selectFirstResult: false
      };
      let PoiLocalSearch = new BMap.LocalSearch(_this.bdMap, PoiOptions);
      PoiLocalSearch.search(this.locationSearch);
    },
      //搜索-高德地图
    searchGdMap() {
      let _this = this;
      let options = this.options;
      let city = null;
      options.forEach(m=>{
        if(m.value == this.currentCity[0]){
          m.children.forEach(n=>{
            if(n.value == this.currentCity[1] ){
              city = n.label;
            }
          })
        }
      })
      const placeSearch = new AMap.PlaceSearch({
        city: city,
        pageSize: 100, // 单页显示结果条数
        pageIndex: 1, // 页码
        citylimit: false,  //是否强制限制在设置的城市内搜索
        autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
      });
      placeSearch.search(this.locationSearch,(status, result)=>{
        _this.searchList = result.poiList.pois;
      });
    },
    //点击搜索后的位置-百度地图
    chooseBdPosition(item){
      const _this = this;
      this.bdMap.clearOverlays();
      this.bdMap.addOverlay(new BMap.Marker(item.point));
      //设置中心点
      this.bdMap.setViewport({ center: item.point, zoom: 16 });
      var geoc = new BMap.Geocoder();
      console.log(item.point)
        geoc.getLocation(item.point, function (rs) {
          console.log(rs)
          let obj = {
            lat: rs.point.lat,
            lng: rs.point.lng,
            address:item.address|| `${rs.addressComponents.province}${rs.addressComponents.city}${rs.addressComponents.district}${rs.addressComponents.street}${rs.addressComponents.streetNumber}`,
            province: _this.getCode('province', rs.addressComponents.province),
            city: _this.getCode('city', rs.addressComponents.province, rs.addressComponents.city),
            district: _this.getCode('district', rs.addressComponents.province, rs.addressComponents.city, rs.addressComponents.district)
          };
          console.log(obj)
          _this.currentPoint = obj;
        })
    },
    //点击搜索后的位置-高德地图
    chooseGdPosition(item){
      let gdMap = this.gdMap ;
      const _this = this;
      let marker = new AMap.Marker({
          icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
          position: [item.location.lng, item.location.lat]
        });
        if (_this.marker) {
          gdMap.remove(_this.marker)
        }
        gdMap.add(marker);
        gdMap.setFitView();
        _this.marker = marker;
        new AMap.Geocoder(null).getAddress([item.location.lng, item.location.lat], function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              let rs  = result.regeocode;
              let obj = {
                lat: item.location.lat,
                lng: item.location.lng,
                address: item.address||`${rs.addressComponent.province}${rs.addressComponent.city || rs.addressComponent.province}${rs.addressComponent.district}${rs.addressComponent.street}${rs.addressComponent.streetNumber}`,
                province: _this.getCode('province', rs.addressComponent.province),
                city: _this.getCode('city', rs.addressComponent.province, rs.addressComponent.city || rs.addressComponent.province),
                district: _this.getCode('district', rs.addressComponent.province, rs.addressComponent.city || rs.addressComponent.province, rs.addressComponent.district),
              };
              _this.currentPoint = obj;
              console.log( _this.currentPoint)
          
            }
        })

    },
    //获取省市区编码
    getCode(type, province, city, district) {
      let code = null;
      if (type == 'province') {
        areaJson.forEach(i => {
          if (i.label == province) {
            code = i.value;
          }
        })
      } else if (type == 'city') {
        areaJson.forEach(m => {
          if (m.children && m.children.length > 0 && province == m.label) {
            m.children.forEach((n) => {
              if (n.label == city) {
                code = n.value;
              }
            });
          }
        })
      } else {
        this.areaJson.forEach(j => {
          if (j.children && j.children.length > 0 && province == j.label) {
            j.children.forEach(k => {
              if (k.children && k.children.length > 0&&city==k.label) {
                k.children.forEach((l) => {
                  if (l.label == district) {
                    code = l.value;
                  }
                });
              }
            });
          }
        })
      }
      return code;
    },
    getMarkers() {
      if(!this.currentPoint) return this.$message.error('请选择位置');
      if (this.mapType == 'gdMap') {
        this.currentPoint.lat = this.gaodeToBaidu(this.currentPoint.lat, this.currentPoint.lng).lat;
        this.currentPoint.lng = this.gaodeToBaidu(this.currentPoint.lat, this.currentPoint.lng).lng;
      }
      this.$emit('getMarkers', this.currentPoint)
      this.$emit('close')
    },
    close(){
      this.$emit('close')
    },
    gaodeToBaidu(lat, lng) {  
      // 高德坐标系与百度坐标系的转换参数  
      const xsPI = 3.14159265358979324 * 3000.0 / 180.0
      const bdlat = Number(lat)
      const bdlng = Number(lng)
      const z = Math.sqrt(bdlng * bdlng + bdlat * bdlat) + 0.00002 * Math.sin(bdlat * xsPI)
      const theta = Math.atan2(bdlat, bdlng) + 0.000003 * Math.cos(bdlng * xsPI)
      const bdslng = z * Math.cos(theta) + 0.0065
      const bdslat = z * Math.sin(theta) + 0.006
      return {lat:bdslat,lng:bdslng};  
    }
  },
};
</script>

<style scoped>
.search-wrap {
  display: flex;
  align-items: center;
}

.wd120 {
  width: 120px;
}

.wd80 {
  width: 60px;
}
.wd300{
  width: 300px;
  margin:0 10px;
}
.map-contain{
  height: 480px;
  display: flex;
  position: relative;
}
.list-wrap{
  width:320px;
  height: 440px;
  margin-top:10px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.map{
  width: 940px;
  height: 440px;
  /* background: #f50; */
  margin-top:10px;
}
.btns{
  display: flex;
  justify-content: flex-end;
  margin-top: 0;
}
.list-wrap .item{
  text-align: left;
  padding: 8px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.list-wrap .item:last-child{
  border-bottom: 0px solid #ccc;
}
.title{
  font-weight: bold;
}
.current-point{
  width: 702px;
  height: 60px;
  line-height: 26px;
  padding-top: 10px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  position: absolute;
  z-index: 2;
  bottom: 20px;
  right: 0px;
}
</style>
